import { createHandlerChainRunner, HasOnError, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";
import { OrderRejectionModel } from "@theStellarBlueprint/CustomApiModel";
import { POSTOrderRejectionReason } from "@theStellarBlueprint/Services/RejectionOrderReasonAPI";
import { CustomApiHandler } from "@theStellarBlueprint/Store/CustomHandlerCreator";

type Parameter = OrderRejectionModel & HasOnSuccess & HasOnError<string>;

type HandlerType = CustomApiHandler<Parameter, ServiceResult<any>>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    console.log("Hello");
    const state = props.getState();
    const cartId = state.pages.orderApprovalDetails.cartId;
    props.apiResult = await POSTOrderRejectionReason({
        cartId: props.parameter.cartId,
        reason: props.parameter.reason,
    });
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult.successful) {
        props.parameter.onSuccess?.();
    }
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    if (!props.apiResult.successful) {
        props.parameter.onError?.(props.apiResult.errorMessage);
    }
};

export const chain = [PopulateApiParameter, RequestDataFromApi, ExecuteOnSuccessCallback, ExecuteOnErrorCallback];

const OrderRejectionReasonHandler = createHandlerChainRunner(chain, "orderRejectionReasonHandler");
export default OrderRejectionReasonHandler;
